import { Badge } from "@/components/ui/badge";
import { TEMPERATURES, statusClass, initials } from "@/lib/crm";
import { cn } from "@/lib/utils";

export function TemperatureBadge({ value, className, size = "sm" }) {
  const t = TEMPERATURES[value] || TEMPERATURES.poco_caldo;
  return (
    <span
      data-testid={`temp-badge-${value}`}
      className={cn(
        "inline-flex items-center gap-1 rounded font-semibold whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm",
        t.badge, className
      )}
    >
      <span>{t.emoji}</span> {t.label}
    </span>
  );
}

export function StatusBadge({ value, className }) {
  return (
    <span className={cn("inline-flex items-center rounded border px-2 py-0.5 text-xs font-medium whitespace-nowrap", statusClass(value), className)}>
      {value}
    </span>
  );
}

export function UserAvatar({ user, size = 28 }) {
  if (!user) return null;
  return (
    <span
      title={user.name}
      className="inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0"
      style={{ width: size, height: size, background: user.color || "#3B82F6", fontSize: size * 0.4 }}
    >
      {initials(user.name)}
    </span>
  );
}
